exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--primary{background-color:#0B5BAC !important}@media screen and (max-width: 600px){.space{margin-bottom:4px}}\n", ""]);

// exports
